import type { ApiResponse } from '@/manage/types/common'

export const isApiResponse = <T>(payload: unknown): payload is ApiResponse<T> => {
  if (!payload || typeof payload !== 'object') return false
  return 'code' in payload && 'data' in payload && 'message' in payload
}

export const unwrapApiData = <T>(payload: ApiResponse<T> | T): T =>
  isApiResponse<T>(payload) ? payload.data : payload

export const unwrapNullableApiData = <T>(payload: ApiResponse<T | null> | T | null): T | null => {
  if (isApiResponse<T | null>(payload)) {
    return payload.data ?? null
  }
  return payload ?? null
}
